module.exports = __webpack_public_path__ + "static/media/Iot_logo.47118eb6.jpg";